import React from "react";
import "../../assets/stylesheets/env-selector.css";

export function navigateToClinicianWebLogin() {
  const url = new URL(window.location.href);
  url.searchParams.set("host", "website");
  url.searchParams.set("apptype", "clinician");
  window.location.href = url.toString();
}

function ClinicianWebLoginSelector({ t }) {
  return (
    <button
      type="button"
      className="settings-clinician-web-login-nav"
      onClick={() => navigateToClinicianWebLogin()}
    >
      {t("login.otp.clinician.redirect.prefix")}
      {" "}
      <span className="settings-clinician-web-login-nav__cta">
        {t("login.otp.clinician.redirect.cta")}
      </span>
    </button>
  );
}

export default ClinicianWebLoginSelector;
